import axios, { AxiosResponse } from 'axios';
import { CampaignResponse } from '../lib/types';
import { IX_MOVED_API_BASE } from '../../../shared/api';
import { env } from '../../../shared/config/env/env';

export const IX_CAMPAIGN_API_BASE = new URL(
	"IXCampaign/api/",
	env.API_ORIGIN,
).toString();

export const tenantHeader = {
	baseURL: IX_CAMPAIGN_API_BASE,
};

export const $tenantApi = axios.create(tenantHeader);
export class Campaign {
	static getCampaignSettings = (campaignId: string): Promise<AxiosResponse<CampaignResponse>> => {
		return $tenantApi.get(`Campaign/${campaignId}`);
	}
}
interface CampaignApi {
	getCampaignSettings(id: string): Promise<AxiosResponse<CampaignResponse>>
}
export const typedCampaign = Campaign as CampaignApi;
